import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CluAgentService } from '../../clu-agent.service';
import { StartupInfos_App_CluAgent, PRINT_ORIENTATION_OPTIONS, PRINT_ORIENTATION } from '../../clu-agent.models';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'md-clu-settings-standard-printer-dialog',
    templateUrl: './md-clu-settings-standard-printer-dialog.component.html'
})
export class MdCluSettingsStandardPrinterDialogComponent implements OnInit {
    loading = false;
    error: string | null = null;
    startupInfos: StartupInfos_App_CluAgent | null = null;
    PRINT_ORIENTATION_OPTIONS = PRINT_ORIENTATION_OPTIONS;
    stdPrinterConfigForm = new FormGroup({
        STD_PRINTER_ID: new FormControl('', Validators.required),
        STD_PRINTER_ORIENTATION: new FormControl(PRINT_ORIENTATION.PORTRAIT, Validators.required),
    });
    
    constructor(
        private ngZone: NgZone,
        private cluAgentService: CluAgentService,
        private matDialogRef: MatDialogRef<MdCluSettingsStandardPrinterDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: { STD_PRINTER_ID: string },
    ) {
        this.stdPrinterConfigForm.controls.STD_PRINTER_ID.patchValue(data.STD_PRINTER_ID);
    }

    ngOnInit() {
        this.matDialogRef.keydownEvents().subscribe(event => { if (event.key === "Escape") { this.close(); } });
        this.cluAgentService.state$.subscribe(infos => {
            if (!!infos.cluParams) {
                this.stdPrinterConfigForm.patchValue({
                    STD_PRINTER_ORIENTATION: infos.cluParams.STD_PRINTER_ORIENTATION
                });
            }
        });
    }
    
    close() {
        this.ngZone.run(() => { this.matDialogRef.close(); });
    }

    async doSubmit() {
        if (this.stdPrinterConfigForm.invalid) { return; }

        this.loading = true;
        this.error = null;
        try {
            const configValues = this.stdPrinterConfigForm.value;
            await this.cluAgentService.doSaveStandardPrinterConfigAction(configValues);
            const agentStateValue = this.cluAgentService.state$.value;
            if (!!agentStateValue?.cluParams) {
                agentStateValue.cluParams.STD_PRINTER_ID = configValues.STD_PRINTER_ID!;
                agentStateValue.cluParams.STD_PRINTER_ORIENTATION = configValues.STD_PRINTER_ORIENTATION!;
                this.cluAgentService.updateStateValue(agentStateValue);
            }
            this.loading = false;
            this.matDialogRef.close();
        } catch(e: any) {
            this.error = e;
            this.loading = false;
        }
    }
}